import React from "react";
import clsx from 'clsx';
import { withRouter, useLocation } from "react-router-dom";
import http from "../../../../http/http";
import LearningNoteCourse from "./LearningNoteCourse";
import LearningNoteAnalysis from "./LearningNoteAnalysis";
import LearningNoteLevel from "./LearningNoteLevel";
import LearningNoteTestResult from "./LearningNoteTestResult";
import useLearningData from "../../../../hooks/useLearningData";
import { TYPE, URL } from "../../../../constant";
import A from "../../../common/A";
import { useUserInfo } from "../../../../hooks";

const LearningNote = withRouter((props) => {
  const { setLearningData } = useLearningData();
  const { info } = useUserInfo();
  const location = useLocation();

  const [tab, setTab] = React.useState("tab1");
  const [levelList, setLevelList] = React.useState([]);
  const [level, setLevel] = React.useState("");
  const [renderFlag, setrenderFlag] = React.useState(false); //진도, 분석 render체크
  const [learner, setLearner] = React.useState(info.learnerId);

  const close = () => {
    props.history.goBack();
  };

  const onChangeFlag = () => {
    setrenderFlag(true);
  };

  const moveResult = (e, item) => {
    e.stopPropagation();
    setLearningData({ stgCd: item.stgCd, prevPage: "learningNote" });
    props.history.push({
      pathname: `${URL.LEARNING.RESULT}`,
      state: {
        stgCd: item.stgCd,
        lrnEntyScnCd: TYPE.LEARNING.COURSE,
      }
      
    });
  };

  const firstLevel = () => {
    if (props.id) {
      setLevel(props.id);
    } else {
      setLevel(levelList[levelList?.length - 1]?.lvlCd);
    }
  };

  const onChangeLevel = (num) => {
    setLevel(num);
  };

  const onChangeTab = (e, num) => {
    e.preventDefault();
    e.stopPropagation();
    setTab(num);
  };

  const getLevelList = () => {
    if (renderFlag) {
      http.request({
        url: `${URL.API.COURSE_LEARNING.NOTE}`
        + `/level/channel/${info.channelCode}`
        + `/language/KO`
        + `/learners/${learner}`,
        
        success: (res) => {
          setLevelList(res);
        }
      });
    }
  };

  const tabBtns = (
    <ul className="tablist cls">
      <li>
        <A
          href="course"
          className={tab === "tab1" ? "active" : ""}
          onClick={(e) => onChangeTab(e, "tab1")}
        >
          진도
        </A>
      </li>
      <li>
        <A
          href="analysis"
          className={tab === "tab2" ? "active" : ""}
          onClick={(e) => onChangeTab(e, "tab2")}
        >
          분석
        </A>
      </li>
      {
        info.channelCode === TYPE.CHANNEL.WJTB && (
          <li>
            <A
              href="testResult"
              className={tab === "tab3" ? "active" : ""}
              onClick={(e) => onChangeTab(e, "tab3")}
            >
              진단
            </A>
          </li>
        )
      }
    </ul>
  )

  React.useEffect(getLevelList, [renderFlag]);
  React.useEffect(firstLevel, [levelList]);
  React.useEffect(() => {
    setLearner(info.learnerId);
  }, [info]);
  React.useEffect(() => {
    sessionStorage.setItem('lastPath', location.pathname);
  }, [])

  return (
    <div className={clsx(
      "layout-def tab-wrap",
      info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'gb' : 'w100p with_bottom_area'
    )}>
      <div className={clsx(
        "header",
        info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'bg_sky' : ''
      )}>
        <div className="inner">
          <div className={clsx(
            "headerBox center",
            info.channelCode === TYPE.CHANNEL.GLOBAL01 ? '' : 'bg_gray'
          )}>
            <div className="w1280">
              <div className="headerBox_head">
                <h1 className="tit">학습노트</h1>
                <button className="btn-close-wrap" onClick={close}>
                  닫기
                </button>
              </div>
            </div>
          </div>
          {
            info.channelCode === TYPE.CHANNEL.GLOBAL01
              ? (
              <div className={clsx("header_tab2")}>
                {tabBtns}
              </div>
              )
              : (
              <div className={clsx("header_tab tab3")}>
                <div className="tab_wrap">
                  {tabBtns}
                </div>
              </div>
              )
            }
        </div>
      </div>
      <div className="container study_note">
        <div className="inner">
          <div className={clsx({
            "study_note_tab1": tab === 'tab1',
            "active": true,
            "tabCont": tab !== "tab3"
          })}>
            <div className="lev_boxes-wrap w800">
              {tab !== "tab3" && (
                <LearningNoteLevel
                  onChangeLevel={onChangeLevel}
                  levelList={levelList}
                  id={props.id}
                />
              )}
              {tab === "tab1" && (
                <LearningNoteCourse
                  onChangeFlag={onChangeFlag}
                  tab={tab}
                  level={level}
                  learner={learner}
                  moveResult={moveResult}
                />
              )}
              {tab === "tab2" && (
                <LearningNoteAnalysis
                  onChangeFlag={onChangeFlag}
                  tab={tab}
                  level={level}
                  learner={learner}
                />
              )}
            </div>
              {tab === "tab3" && (
                <LearningNoteTestResult
                  onChangeFlag={onChangeFlag}
                  tab={tab}
                  level={level}
                  learner={learner}
                />
              )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default LearningNote;
